import React from 'react';
import { AppContextProvider } from '../context/AppContext';
import controlStyles from './Wrapper.module.scss';
import variantStyles from './Wrapper.vibefirst.module.scss';
import { getVariantStyles } from '@/utils/listingsVibeFirst';

interface WrapperProps {
  children: React.ReactNode;
  serverUrl: string;
  stage: string;
  locale: string;
  isVibeFirstVariantActive?: boolean;
}

export const Wrapper = ({ children, serverUrl, stage, locale, isVibeFirstVariantActive = false }: WrapperProps) => {
  const styles = getVariantStyles(isVibeFirstVariantActive, controlStyles, variantStyles);

  return (
    <AppContextProvider serverUrl={serverUrl} stage={stage} locale={locale}>
      <div className={styles.root} data-listings-vibe-first={isVibeFirstVariantActive ? 'true' : undefined}>
        {children}
      </div>
    </AppContextProvider>
  );
};
